import { DateTime } from 'luxon';

export function DateCell({ date }: { date?: string }) {
  return date ? <>{DateTime.fromISO(date).toLocaleString()}</> : null;
}
